import { cn } from "../lib/utils";

export function LogoMark({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className={cn("h-[18px] w-auto text-primary", className)}
    >
      <circle cx="3" cy="6" r="3" fill="currentColor" />
      <circle cx="12" cy="6" r="1.25" fill="currentColor" fillOpacity="0.55" />
      <circle cx="17" cy="6" r="1.25" fill="currentColor" fillOpacity="0.3" />
      <circle
        cx="27"
        cy="6"
        r="2.75"
        stroke="currentColor"
        strokeWidth="1.6"
      />
    </svg>
  );
}

type LogoSize = "sm" | "md" | "lg";
type LogoOrientation = "horizontal" | "vertical";

const LOGO_SIZES: Record<
  LogoSize,
  { mark: string; text: string; gapH: string; gapV: string; tracking: string }
> = {
  sm: {
    mark: "h-[18px]",
    text: "text-[15px]",
    gapH: "gap-2",
    gapV: "gap-1.5",
    tracking: "tracking-tight",
  },
  md: {
    mark: "h-6",
    text: "text-lg",
    gapH: "gap-2.5",
    gapV: "gap-2",
    tracking: "tracking-tight",
  },
  lg: {
    mark: "h-12",
    text: "text-sm",
    gapH: "gap-3",
    gapV: "gap-3",
    tracking: "tracking-[0.25em] uppercase",
  },
};

export function Logo({
  size = "sm",
  orientation = "horizontal",
  className,
}: {
  size?: LogoSize;
  orientation?: LogoOrientation;
  className?: string;
}) {
  const s = LOGO_SIZES[size];
  const isVertical = orientation === "vertical";
  return (
    <span
      className={cn(
        "inline-flex items-center",
        isVertical ? `flex-col ${s.gapV}` : s.gapH,
        className,
      )}
    >
      <LogoMark className={s.mark} />
      <span
        className={cn(
          "font-semibold",
          s.text,
          s.tracking,
          isVertical && size === "lg" && "text-muted-foreground font-medium",
        )}
      >
        tracelink
      </span>
    </span>
  );
}
